import useFooterStyles from "./Footer.styles";
import { useIsMobile } from "../../hooks";
import Container from "../../components/Container";
import Typography from "../../components/Typography";
import { customTokens } from "../../theme/theme";
import flicker from "../../assets/images/flicker.svg";
import instagram from "../../assets/images/instagram.svg";
import linkedIn from "../../assets/images/linkedIn.svg";
import facebook from "../../assets/images/facebook.svg";
import x from "../../assets/images/x.svg";
import youtube from "../../assets/images/youtube.svg";

const legalLinks = [
  { label: "Terms of use", path: "https://unfccc.int/this-site/terms-of-use" },
  { label: "Fraud Alert", path: "https://unfccc.int/this-site/fraud-alert" },
];

const unfcccLinks = [
  {
    label: "Contact",
    path: "https://unfccc.int/about-us/contact-and-directions/find-contact-by-issue",
  },
  { label: "Documents and decisions", path: "https://unfccc.int/documents" },
  { label: "UN Climate Change News", path: "https://unfccc.int/news" },
];

const socialLinks = [
  { label: "X", icon: x, path: "https://twitter.com/unfccc" },
  {
    label: "Facebook",
    icon: facebook,
    path: "https://www.facebook.com/UNclimatechange",
  },
  {
    label: "Linkedin",
    icon: linkedIn,
    path: "https://www.linkedin.com/company/unfccc",
  },
  {
    label: "Instagram",
    icon: instagram,
    path: "https://www.instagram.com/unclimatechange/#",
  },
  {
    label: "Flicker",
    icon: flicker,
    path: "https://www.flickr.com/photos/unfccc/",
  },
  {
    label: "YouTube",
    icon: youtube,
    path: "https://www.youtube.com/user/climateconference",
  },
];

const Footer = () => {
  const styles = useFooterStyles();
  const isMobile = useIsMobile();

  const handleLinkClick = (url: string) => {
    window.open(url, "_blank");
  };

  return (
    <Container className={styles.footer}>
      {isMobile && (
        <div className={styles.socialLinkMobileWrapper}>
          <div className={styles.socialLinkWrapper}>
            {socialLinks.map((item) => {
              return (
                <div
                  className={styles.socialLink}
                  onClick={() => handleLinkClick(item.path)}
                >
                  <img src={item.icon} alt={item.label} />
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className={styles.bottomContainer}>
        <div className={styles.column}>
          <Typography
            variant="bodyLSemibold"
            tabletVariant="bodyLSemibold"
            mobileVariant="bodySSemibold"
            color={customTokens.colorNeutralForegroundStaticInverted}
          >
            Legal
          </Typography>

          <div className={styles.linkWrapper}>
            {legalLinks.map((item) => {
              return (
                <Typography
                  variant="body1"
                  tabletVariant="body1"
                  mobileVariant="body1"
                  className={styles.link}
                  color={customTokens.colorNeutralForegroundInvertedLink}
                  onClick={() => handleLinkClick(item.path)}
                >
                  {item.label}
                </Typography>
              );
            })}
          </div>
        </div>

        <div className={styles.column}>
          <Typography
            variant="bodyLSemibold"
            tabletVariant="bodyLSemibold"
            mobileVariant="bodySSemibold"
            color={customTokens.colorNeutralForegroundStaticInverted}
          >
            UNFCCC
          </Typography>

          <div className={styles.linkWrapper}>
            {unfcccLinks.map((item) => {
              return (
                <Typography
                  variant="body1"
                  tabletVariant="body1"
                  mobileVariant="body1"
                  className={styles.link}
                  color={customTokens.colorNeutralForegroundInvertedLink}
                  onClick={() => handleLinkClick(item.path)}
                >
                  {item.label}
                </Typography>
              );
            })}
          </div>
        </div>

        {!isMobile && (
          <div className={styles.column}>
            <Typography
              variant="bodyLSemibold"
              tabletVariant="bodyLSemibold"
              mobileVariant="bodySSemibold"
              color={customTokens.colorNeutralForegroundStaticInverted}
            >
              Social
            </Typography>

            <div className={styles.socialLinkWrapper}>
              {socialLinks.map((item) => {
                return (
                  <div
                    className={styles.socialLink}
                    onClick={() => handleLinkClick(item.path)}
                  >
                    <img
                      src={item.icon}
                      alt={item.label}
                      width="16px"
                      height="16px"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default Footer;
